import { withBasePath } from "@/helpers/basePath";
import phone from "@/images/price-cards/phone.png";
import router from "@/images/price-cards/router.png";
import tv from "@/images/price-cards/tv.png";
import type { StaticImageData } from "next/image";

import type { BundleProductImageType } from "./types";

export interface BundleProductImage {
  src: StaticImageData;
  alt: string;
}

const priceProductCardBackgroundPath: string = withBasePath(
  "/images/heroes/backgrounds/"
);

export const PRICE_PRODUCT_CARD_IMAGES = {
  mobileCondensedBackground: {
    src: `${priceProductCardBackgroundPath}mobile-condensed-background.jpg`,
  },
} as const;

export const BUNDLE_PRODUCT_IMAGES: Record<
  BundleProductImageType,
  BundleProductImage
> = {
  router: { src: router, alt: "Xfinity router" },
  phone: { src: phone, alt: "Xfinity mobile phone" },
  tv: { src: tv, alt: "Xfinity TV" },
};
